/* eslint-disable i18next/no-literal-string -- styles not user facing */
import { defineSlotRecipe } from '@chakra-ui/react';

export const breadcrumb = defineSlotRecipe({
  className: 'chakra-breadcrumb',
  slots: ['item', 'link', 'list', 'separator', 'currentLink'],
  base: {
    list: {
      display: 'flex',
      alignItems: 'center',
      wordBreak: 'break-word',
      color: 'fg.muted',
      maxWidth: 'full',
      fontSize: 'md',
    },
    link: {
      // Override default styles here - default assumes items will be links so gives pointer and hover underline
      // Empty string overrides default breadcrumb style, but still allows a link component to override these
      cursor: '',
      padding: 1,
      margin: -1,
      _hover: {
        textDecoration: '',
      },
      fontWeight: 'inherit',
      // Item styling
      color: 'on-navy.300',
      fontSize: 'md',
    },
    // Selected item styling
    currentLink: {
      color: 'gray.900',
      background: 'blue.50',
      borderRadius: 'sm',
      padding: 1,
      fontSize: 'md',
      _dark: {
        background: 'none',
        fontWeight: 'semibold',
      },
    },
    item: {
      display: 'inline-flex',
      alignItems: 'center',
      // Item styling
      color: 'on-navy.300',
      fontSize: 'md',
    },
    separator: {
      color: 'gray.600',
      fontSize: 'lg',
    },
  },
});
